import React, { createContext, useContext, useState } from 'react';

const ParcelContext = createContext();

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes en millisecondes

//used in v2 only
export function ParcelProvider({ children }) {
    const [currentParcelId, setCurrentParcelId] = useState(null);
    const [parcelData, setParcelData] = useState(null);
    const [lastFetchTime, setLastFetchTime] = useState(null);

    const needsFetch = (parcelId) => {
        // Si parcelId est vide/null/undefined, réinitialiser
        if (!parcelId || parcelId === 'null' || parcelId === 'undefined') {
            if (currentParcelId !== null) {
                clearParcelData();
            }
            return false;
        }
        
        // Nouveau parcelId ou pas de données
        if (currentParcelId !== parcelId || parcelData === null) {
            return true;
        }
        
        // Même parcelId mais cache expiré (> 5 min)
        const now = Date.now();
        if (now - lastFetchTime > CACHE_DURATION) {
            return true;
        }
        
        return false;
    };

    const updateParcelData = (parcelId, data) => {
        setCurrentParcelId(parcelId);
        setParcelData(data);
        setLastFetchTime(Date.now());
    };

    const clearParcelData = () => {
        setCurrentParcelId(null);
        setParcelData(null);
        setLastFetchTime(null);
    };

    return (
        <ParcelContext.Provider value={{ 
            currentParcelId,
            parcelData,
            needsFetch,
            updateParcelData,
            clearParcelData
        }}>
            {children}
        </ParcelContext.Provider>
    );
}

export function useParcel() {
    const context = useContext(ParcelContext);
    if (!context) {
        throw new Error('useParcel must be used within a ParcelProvider');
    }
    return context;
}
